import React, { PureComponent } from 'react';
import { message, Modal, AutoComplete, Form, Row, Col, Input } from 'antd-v5';
import {
  getMasterCustomListRequest,
  updateBuyerInfoRequest,
} from '../../../state/request/payEntryData';
const FormItem = Form.Item;

class EditBuyer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      buyerList: [],
      selectedBuyer: {},
      buyerName: '',
      phone: '',
    };
    this.formRef = null;
  }

  getBuyerNameList = (value) => {
    this.getCustomList({ buyerName: value });
  };

  getPhoneList = (value) => {
    this.getCustomList({ buyerPhone: value });
  };

  getCustomList = async (params) => {
    const res = await getMasterCustomListRequest({
      ...params,
      stallId: this.props.data?.stallId,
    });
    const { code, data = [] } = res || {};
    if (code === 200) {
      this.setState({
        buyerList: data,
      });
    }
  };

  setSelectedBuyer = (buyerUid) => {
    const buyer = this.state.buyerList.find((item) => item.buyerUid === buyerUid);
    if (buyer) {
      this.setState({
        selectedBuyer: buyer,
        buyerName: buyer.buyerName,
        phone: buyer.phone,
      });
      this.formRef.setFieldsValue({
        debtorName: buyer.buyerName,
      });
    }
  };

  updateBuyerInfo = async (values) => {
    const { onClose, onRefresh } = this.props;
    const { id } = this.props.data;
    const { debtorName, debtorPhone } = values;
    const { selectedBuyer } = this.state;
    const { buyerUid = '' } = selectedBuyer;
    const { code } = await updateBuyerInfoRequest({
      id,
      buyerId: buyerUid,
      debtorName,
      debtorPhone,
    });
    if (code === 200) {
      message.success('更新成功');
      onClose();
      onRefresh();
    }
  };

  render() {
    const { buyerList, selectedBuyer, buyerName, phone } = this.state;
    const { buyerUid = '' } = selectedBuyer;
    const { visible, onClose, data } = this.props;
    const { debtorId } = data;

    return (
      <>
        <Modal
          title={'编辑信息'}
          visible={visible}
          onOk={() => this.formRef.submit()}
          onCancel={() => onClose()}
          destroyOnClose
          maskClosable={false}
        >
          <Form
            layout='vertical'
            ref={(r) => {
              this.formRef = r;
            }}
            initialValues={data}
            onFinish={this.updateBuyerInfo}
          >
            <Row gutter={16}>
              <Col span={12}>
                <FormItem label='被追讨人姓名' name='debtorName'>
                  <Input disabled />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  rules={[
                    { required: true, message: '请输入被追讨人手机号' },
                    {
                      pattern: /^((\+)?86|((\+)?86)?)0?1\d{10}$/,
                      message: '请输入正确的手机号格式',
                    },
                  ]}
                  label='被追讨人手机号'
                  name='debtorPhone'
                >
                  <Input disabled />
                </FormItem>
              </Col>
            </Row>
            <Row style={{ marginBottom: 16 }}>买家ID：{buyerUid || debtorId || ''}</Row>
            <Row gutter={16}>
              <Col span={12}>
                <FormItem label='买家姓名'>
                  <AutoComplete
                    options={buyerList.map((item) => ({
                      value: item.buyerUid,
                      label: item.buyerName,
                    }))}
                    onSelect={(value) => this.setSelectedBuyer(value)}
                    value={buyerName}
                  >
                    <Input.Search
                      value={buyerName}
                      onChange={(e) => this.setState({ buyerName: e.target.value })}
                      placeholder='请输入买家姓名'
                      onSearch={this.getBuyerNameList}
                    />
                  </AutoComplete>
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem label='买家手机号'>
                  <AutoComplete
                    options={buyerList
                      .filter((item) => item.phone)
                      .map((item) => ({
                        value: item.buyerUid,
                        label: item.phone,
                      }))}
                    onSelect={(value) => this.setSelectedBuyer(value)}
                    value={phone}
                  >
                    <Input.Search
                      value={phone}
                      onChange={(e) => this.setState({ phone: e.target.value })}
                      placeholder='请输入买家手机号'
                      onSearch={this.getPhoneList}
                    />
                  </AutoComplete>
                </FormItem>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    );
  }
}
export default EditBuyer;
